export const TIPS_SETTINGS_KEY = 'TIPS_LIST';
